
import SettingsInputCompositeIcon from '@mui/icons-material/SettingsInputComposite';
import LineStyleIcon from '@mui/icons-material/LineStyle';
import RoundedCornerIcon from '@mui/icons-material/RoundedCorner';
import CategoryIcon from '@mui/icons-material/Category';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';
import FormatSizeIcon from '@mui/icons-material/FormatSize';
import AutofpsSelectIcon from '@mui/icons-material/AutofpsSelect';
import SettingsIcon from '@mui/icons-material/Settings';
import PolylineIcon from '@mui/icons-material/Polyline';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AssignmentIcon from '@mui/icons-material/Assignment';



const PharmaConfiguration = {
  id: '5',
  title: 'Pharma Configuration',
  type: 'group',
  role: ' PHARMA_OMS_ADMIN, PHARMA_OMS_QA',
  children: [
    {
      id: 'taskmgmt',
      title: 'Task Management',
      type: 'item',
      url: '/',
      bottomMenu:'TASK-MANAGEMENT',
      icon: AssignmentIcon
    }
    ,
    {
      id: 'tagging',
      title: 'Tagging',
      type: 'item',
      url: '/',
      bottomMenu:'TAGGING',
      icon: LocalOfferIcon
    },
    /*
    {
      id: 'composition',
      title: 'Composition',
      type: 'item',
      url: '/composition',
      icon: SettingsInputCompositeIcon
    }, */
    {
          id: 'foodcomposition',
          title: 'Food Composition',
          type: 'item',
          url: '/',
          bottomMenu:'FOOD-COMPOSITION',
          icon: PolylineIcon
        },
    {
      id: 'phpackagingmaterial',
      title: 'Packaging Material',
      type: 'item',
      url: '/phpackagingmaterial',
      icon: LineStyleIcon
    },{
      id: 'phproductform',
      title: 'Product Form',
      type: 'item',
      url: '/phproductform',
      icon: RoundedCornerIcon
    },{
      id: 'phproductshape',
      title: 'Shape',
      type: 'item',
      url: '/phproductshape',
      icon: CategoryIcon
    },{
      id: 'compositiontemplate',
      title: 'Composition',
      type: 'item',
      url: '/compositiontemplatepage',
      icon: SettingsInputComponentIcon
    },{
      id: 'rmunit',
      title: 'Unit',
      type: 'item',
      url: '/rmunit',
      icon: SettingsIcon
    },{
      id: 'packagingsize',
      title: 'Packaging Size',
      type: 'item',
      url: '/packagingsize',
      icon: FormatSizeIcon
    },{
      id: 'pharmaset',
      title: 'Set',
      type: 'item',
      url: '/pharmaset',
      icon: AutofpsSelectIcon
    },
    {
      id: 'gst',
      title: 'GST',
      type: 'item',
      url: '/gstpage',
      icon: AutofpsSelectIcon
    },
    // {
    //   id: 'saltpage',
    //   title: 'Salt',
    //   type: 'item',
    //   url: '/saltpage',
    //   icon: AutofpsSelectIcon
    // }
    // ,{
    //   id: 'partystatus',
    //   title: 'Party Status',
    //   type: 'item',
    //   url: '/partystatus',
    //   icon: SettingsIcon
    // },
  ]
};

export default PharmaConfiguration;